/**
 * Anvil LOC Configured Token Pairs
 * Fetched from Mainnet contract on 2026-02-18
 */

export interface LOCPair {
  collateral: string
  collateralAddress: `0x${string}`
  credited: string
  creditedAddress: `0x${string}`
  creationFactorBps: number
  maintenanceFactorBps: number
  liquidatorIncentiveBps: number
}

export const CONFIGURED_LOC_PAIRS: LOCPair[] = [
  {
    collateral: 'WETH',
    collateralAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    credited: 'USDC',
    creditedAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    creationFactorBps: 5600, // 56% - need 178% collateral
    maintenanceFactorBps: 6600, // 66% - maintain 151% collateral
    liquidatorIncentiveBps: 800, // 8%
  },
  {
    collateral: 'WETH',
    collateralAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    credited: 'USDT',
    creditedAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    creationFactorBps: 5600,
    maintenanceFactorBps: 6600,
    liquidatorIncentiveBps: 800,
  },
  {
    collateral: 'USDC',
    collateralAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    credited: 'USDT',
    creditedAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    creationFactorBps: 7100,
    maintenanceFactorBps: 8300,
    liquidatorIncentiveBps: 800,
  },
  {
    collateral: 'USDT',
    collateralAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    credited: 'USDC',
    creditedAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    creationFactorBps: 7100,
    maintenanceFactorBps: 8300,
    liquidatorIncentiveBps: 800,
  },
  {
    collateral: 'wBTC',
    collateralAddress: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    credited: 'USDC',
    creditedAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    creationFactorBps: 6000,
    maintenanceFactorBps: 7100,
    liquidatorIncentiveBps: 800,
  },
]

/**
 * Check if a token pair is configured
 */
export function isPairConfigured(
  collateralAddress: string,
  creditedAddress: string
): boolean {
  return CONFIGURED_LOC_PAIRS.some(
    p =>
      p.collateralAddress.toLowerCase() === collateralAddress.toLowerCase() &&
      p.creditedAddress.toLowerCase() === creditedAddress.toLowerCase()
  )
}

/**
 * Get pair configuration
 */
export function getPairConfig(
  collateralAddress: string,
  creditedAddress: string
): LOCPair | undefined {
  return CONFIGURED_LOC_PAIRS.find(
    p =>
      p.collateralAddress.toLowerCase() === collateralAddress.toLowerCase() &&
      p.creditedAddress.toLowerCase() === creditedAddress.toLowerCase()
  )
}

/**
 * Get available credited tokens for a given collateral token
 */
export function getAvailableCreditedTokens(
  collateralAddress: string
): Array<{ symbol: string; address: `0x${string}` }> {
  return CONFIGURED_LOC_PAIRS.filter(
    p => p.collateralAddress.toLowerCase() === collateralAddress.toLowerCase()
  ).map(p => ({
    symbol: p.credited,
    address: p.creditedAddress,
  }))
}
